import { WordCloud } from '@ant-design/plots';

const WordCloudChart = (props) => {
  const data = [];

  if (Object.keys(props.data).length > 0) {
    for (const word in props.data) {
      data.push({
        word: word,
        value: props.data[word]['value'],
        color: props.data[word]['color'],
      });
    }
  }

  const config = {
    data,
    wordField: 'word',
    weightField: 'value',
    color: (data) => {
      console.log(data);
      return data.datum ? data.datum.color : 'white';
    },
    wordStyle: {
      fontFamily: 'Verdana',
      fontSize: [24, 80],
    },
    interactions: [
      {
        type: 'element-active',
      },
    ],
    state: {
      active: {
        style: {
          lineWidth: 3,
        },
      },
    },
    tooltip: false,
  };

  return (
    <div style={{ width: '30em', height: '30em', margin: 'auto' }}>
      <WordCloud {...config} />
    </div>
  );
};

export default WordCloudChart;
